const S3_BASE = 'https://packageplusmainsys.s3-ap-northeast-1.amazonaws.com/';

/**
 * 後台存的圖有兩種:完整網址(imgur 等)、舊站上傳到 S3 的相對路徑(coupon/xxx/yyy.png)。
 * 相對路徑直接塞進 <img> 會變成打 vip 網域而破圖,要補上 S3 網址。
 * 舊站搬來的資料有存成字串 "null" 的,當作沒有圖。
 */
export const resolveImageUrl = (url?: string | null): string => {
  const u = (url ?? '').trim();
  if (!u || u.toLowerCase() === 'null') {
    return '';
  }
  if (/^https?:\/\//i.test(u)) {
    return u;
  }
  return S3_BASE + u.replace(/^\/+/, '');
};
